import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId, useCurrentProfileId } from '@mews-commander/core';

export const useGetCurrentProfileCashiersSuspense = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const currentProfileId = useCurrentProfileId();

    return useRepositorySuspenseQuery(
        'cashiers',
        'getAll',
        { enterpriseId, assignedProfileIds: [currentProfileId] },
        {
            select: (data) => data.cashiers?.filter((c) => c.enabledCurrencies.length),
        }
    );
};
